const dayjs = require('dayjs');
var isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
dayjs.extend(isSameOrAfter);

function PMT(ir, np, pv, fv, type) {
  let pmt, pvif;

  fv || (fv = 0);
  type || (type = 0);

  if (ir === 0) return -(pv + fv) / np;

  pvif = Math.pow(1 + ir, np);
  pmt = (-ir * (pv * pvif + fv)) / (pvif - 1);

  if (type === 1) pmt /= 1 + ir;

  return pmt;
}

const interestAccrued = function (amount, rate, disbursementDate, firstRepaymentDate) {
  const days = firstRepaymentDate.diff(disbursementDate, 'day');
  return amount * (days / 365.25) * rate;
};

const calculatorCache = {};

function calculateLoanTerms(
  interestRate,
  disbursements,
  adminFee,
  loanTermInMonths,
  firstRepaymentDate,
  gracePaymentAmount,
  gracePeriodInMonths,
) {
  // this function should always return the same result for the same arguments,
  // so it's safe to cache the result.
  const cacheKey = JSON.stringify(arguments);
  if (calculatorCache[cacheKey]) {
    return calculatorCache[cacheKey];
  }

  firstRepaymentDate = dayjs(firstRepaymentDate);
  disbursements = disbursements.map(d => {
    return { date: dayjs(d.date), amount: d.amount };
  });
  disbursements.sort((a, b) => a.date.diff(b.date));

  disbursements[0].amount += Number(adminFee);

  const totalDisbursementAmount = disbursements.reduce((acc, d) => acc + d.amount, 0);
  const firstDisbursementDate = disbursements[0].date;

  let simpleInterest = 0.0;
  let transactions = [];

  for (let i = 0; i < disbursements.length; i++) {
    const disbursement = disbursements[i];
    const disbursementDate = disbursement.date;
    simpleInterest += interestAccrued(
      disbursement.amount,
      interestRate,
      disbursementDate,
      firstRepaymentDate,
    );
    transactions.push({
      date: disbursementDate,
      yearFractionFromFirstDisbursement: disbursementDate.diff(firstDisbursementDate, 'days') / 365,
      amount: disbursement.amount,
    });
  }

  let balanceAtFirstRepayment =
    simpleInterest + totalDisbursementAmount - gracePaymentAmount * gracePeriodInMonths;

  let monthlyRepayment = PMT(interestRate / 12, loanTermInMonths, balanceAtFirstRepayment);

  for (let i = 0; i < loanTermInMonths; i++) {
    var thisRepaymentDate = firstRepaymentDate.add(i, 'month');
    transactions.push({
      date: thisRepaymentDate,
      yearFractionFromFirstDisbursement:
        thisRepaymentDate.diff(firstDisbursementDate, 'days') / 365,
      amount: monthlyRepayment,
    });
  }
  const kfi = {
    monthlyRepayment: -monthlyRepayment,
    totalRepayable: -monthlyRepayment * loanTermInMonths,
    totalCashPrice: totalDisbursementAmount,
    totalInterest: -monthlyRepayment * loanTermInMonths - totalDisbursementAmount,
    loanTermInYears: loanTermInMonths / 12,
    firstRepaymentDate: firstRepaymentDate,
    adminFee: adminFee,
  };

  calculatorCache[cacheKey] = kfi;
  return kfi;
}

export { calculateLoanTerms };
